import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** Friendly address scalar that automatically converts to EIP55 format */
  FriendlyAddress: { input: any; output: any; }
  /** Normalized address scalar that automatically converts to lowercase */
  NormalizedAddress: { input: any; output: any; }
};

export type CapsuleMintPermit = {
  permit: Scalars['String']['output'];
};

export type CapsuleNftStats = {
  abi: Scalars['String']['output'];
  contractAddress: Scalars['String']['output'];
  mintedCount: Scalars['Float']['output'];
};

export type CapsulePiece = {
  dayIndex: Scalars['Int']['output'];
  tokenAddress: Scalars['String']['output'];
  tokenImageUrl?: Maybe<Scalars['String']['output']>;
  tokenName: Scalars['String']['output'];
};

export type CreateUserInput = {
  inviteCode?: InputMaybe<Scalars['String']['input']>;
  skipInviteBind?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DefaultMeta = {
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<Scalars['String']['output']>;
  historyId?: Maybe<Scalars['String']['output']>;
};

export type Discord = {
  avatar: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DiscordMissionMeta = {
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<Scalars['String']['output']>;
  historyId?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
};

export type GetRecordsPaginationInput = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
};

export type GlobalStats = {
  capsuleNFT: CapsuleNftStats;
  totalParticipants: Scalars['Int']['output'];
  totalTransactions: Scalars['Int']['output'];
  totalTvl: Scalars['Float']['output'];
};

export type Invitation = {
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invitee: User;
  inviteeAddress: Scalars['String']['output'];
  inviter: User;
  inviterAddress: Scalars['String']['output'];
  nftTokenId?: Maybe<Scalars['String']['output']>;
  rewardPaid: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
};

export type LuckyDrawPrepareResponse = {
  drawCount: Scalars['Int']['output'];
  expiresAt: Scalars['Int']['output'];
  historyId: Scalars['String']['output'];
  signature: Scalars['String']['output'];
};

export type LuckyDrawReward = {
  amount: Scalars['String']['output'];
  decimal: Scalars['Int']['output'];
  index: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  maxDrawPerRound: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  weight: Scalars['String']['output'];
};

export type LuckyDrawRewardStats = {
  drawnCount: Scalars['Int']['output'];
  index: Scalars['Int']['output'];
};

export type LuckyDrawRoundStats = {
  pointsPerDraw: Scalars['String']['output'];
  rewardDrawn: Array<LuckyDrawRewardStats>;
  round: Scalars['Int']['output'];
  totalDrawCount: Scalars['Int']['output'];
  uniqueUsersCount: Scalars['Int']['output'];
};

export type LuckyDrawUserHistoryRecord = {
  createdAt: Scalars['String']['output'];
  drawCount: Scalars['Int']['output'];
  drawDate: Scalars['String']['output'];
  id: Scalars['String']['output'];
  rewards: Array<LuckyDrawRewardStats>;
  txHash: Scalars['String']['output'];
};

export type LuckyDrawUserHistoryRecordResponse = {
  items: Array<LuckyDrawUserHistoryRecord>;
  pagination: PaginationDto;
};

export type LuckyDrawUserStats = {
  todayConsumedDraws: Scalars['Int']['output'];
  todayEligibility: Scalars['Boolean']['output'];
  todayMaxDraws: Scalars['Int']['output'];
  todayOnChainTaskEligibility: Scalars['Boolean']['output'];
  todayRemainingDraws: Scalars['Int']['output'];
  totalAvailableDraws: Scalars['Int']['output'];
  totalConsumedDraws: Scalars['Int']['output'];
  totalConsumedPoints: Scalars['String']['output'];
  totalEarnedPoints: Scalars['String']['output'];
  totalRemainingPoints: Scalars['String']['output'];
  totalRewards: Array<LuckyDrawRewardStats>;
};

export type Mutation = {
  bindInviteCode: User;
  createUser: User;
  luckyDrawPreparation: LuckyDrawPrepareResponse;
  luckyDrawSaveTxHash: Scalars['Boolean']['output'];
  setUserName: User;
  skipInviteBind: User;
  startMission: UserMission;
  syncMissionStatus: UserMission;
};


export type MutationBindInviteCodeArgs = {
  address: Scalars['NormalizedAddress']['input'];
  inviteCode: Scalars['String']['input'];
};


export type MutationCreateUserArgs = {
  address: Scalars['NormalizedAddress']['input'];
  input?: InputMaybe<CreateUserInput>;
};


export type MutationLuckyDrawPreparationArgs = {
  address: Scalars['NormalizedAddress']['input'];
  signature: Scalars['String']['input'];
  value: PrepareDrawValue;
};


export type MutationLuckyDrawSaveTxHashArgs = {
  address: Scalars['NormalizedAddress']['input'];
  historyId: Scalars['String']['input'];
  txHash: Scalars['String']['input'];
};


export type MutationSetUserNameArgs = {
  address: Scalars['NormalizedAddress']['input'];
  name: Scalars['String']['input'];
};


export type MutationSkipInviteBindArgs = {
  address: Scalars['NormalizedAddress']['input'];
};


export type MutationStartMissionArgs = {
  address: Scalars['NormalizedAddress']['input'];
  missionId: Scalars['Int']['input'];
};


export type MutationSyncMissionStatusArgs = {
  address: Scalars['NormalizedAddress']['input'];
  historyId: Scalars['String']['input'];
};

export type NftMissionMeta = {
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<Scalars['String']['output']>;
  historyId?: Maybe<Scalars['String']['output']>;
  tokenAddress: Scalars['String']['output'];
  tokenId?: Maybe<Scalars['String']['output']>;
  tokenImageUrl?: Maybe<Scalars['String']['output']>;
  tokenName: Scalars['String']['output'];
};

export type PaginationDto = {
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PrepareDrawValue = {
  address: Scalars['String']['input'];
  costPoints: Scalars['String']['input'];
  date: Scalars['String']['input'];
  drawCount: Scalars['Int']['input'];
  issuedAt: Scalars['Int']['input'];
};

export type Query = {
  capsuleMintPermit: CapsuleMintPermit;
  capsulePieces: Array<CapsulePiece>;
  global: GlobalStats;
  inviteRankings: Array<RankingResult>;
  luckyDrawCurrentRoundStats: LuckyDrawRoundStats;
  luckyDrawRewards: Array<LuckyDrawReward>;
  luckyDrawUserHistories: LuckyDrawUserHistoryRecordResponse;
  luckyDrawUserStats: LuckyDrawUserStats;
  queryUserByInviteCode: User;
  season1Rankings: Array<Season1RankingResult>;
  season2Rankings: Array<Season2RankingResult>;
  user: User;
  userCapsulePieces: Array<UserCapsulePiece>;
  userClaimGasEligible: UserClaimGasEligibility;
  userGECStatsV2?: Maybe<UserGecStatsV2>;
  userMissions: Array<UserMission>;
  userRank: RankingResult;
  userSeason2MissionStatus: Array<Scalars['Boolean']['output']>;
  userSocialProfileMissions: Array<SocialProfileMission>;
  verifyRecaptcha: Scalars['Boolean']['output'];
};


export type QueryCapsuleMintPermitArgs = {
  address: Scalars['String']['input'];
};


export type QueryInviteRankingsArgs = {
  first?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  type?: Scalars['String']['input'];
};


export type QueryLuckyDrawUserHistoriesArgs = {
  address: Scalars['NormalizedAddress']['input'];
  pagination: GetRecordsPaginationInput;
};


export type QueryLuckyDrawUserStatsArgs = {
  address: Scalars['NormalizedAddress']['input'];
};


export type QueryQueryUserByInviteCodeArgs = {
  inviteCode: Scalars['String']['input'];
};


export type QueryUserArgs = {
  address: Scalars['NormalizedAddress']['input'];
};


export type QueryUserCapsulePiecesArgs = {
  address: Scalars['NormalizedAddress']['input'];
};


export type QueryUserClaimGasEligibleArgs = {
  address: Scalars['NormalizedAddress']['input'];
  dayIndex: Scalars['Int']['input'];
};


export type QueryUserGecStatsV2Args = {
  address: Scalars['NormalizedAddress']['input'];
};


export type QueryUserMissionsArgs = {
  address: Scalars['NormalizedAddress']['input'];
};


export type QueryUserRankArgs = {
  address: Scalars['NormalizedAddress']['input'];
  type: Scalars['String']['input'];
};


export type QueryUserSeason2MissionStatusArgs = {
  address: Scalars['NormalizedAddress']['input'];
};


export type QueryUserSocialProfileMissionsArgs = {
  address: Scalars['NormalizedAddress']['input'];
};


export type QueryVerifyRecaptchaArgs = {
  token: Scalars['String']['input'];
};

export type RankingResult = {
  address: Scalars['String']['output'];
  inviteCount: Scalars['Float']['output'];
  rank: Scalars['Float']['output'];
  totalPoint: Scalars['String']['output'];
};

export type Season1RankingResult = {
  address: Scalars['FriendlyAddress']['output'];
  rank: Scalars['Float']['output'];
  totalPoint: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type Season1Stats = {
  totalGEC: Scalars['String']['output'];
  totalPoint: Scalars['String']['output'];
};

export type Season2RankingResult = {
  address: Scalars['FriendlyAddress']['output'];
  inviteeCount: Scalars['Float']['output'];
  rank: Scalars['Float']['output'];
  totalPoint: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type Season2Stats = {
  basicPoint: Scalars['String']['output'];
  hbNftBoost: Scalars['String']['output'];
  invitationBoost: Scalars['String']['output'];
  invitationCount: Scalars['Int']['output'];
};

export type Season3Stats = {
  invitationCount: Scalars['Int']['output'];
  invitationPoint: Scalars['String']['output'];
  onChainPoint: Scalars['String']['output'];
  socialPoint: Scalars['String']['output'];
};

export type Season4Stats = {
  totalConsumedPoints: Scalars['String']['output'];
  totalEarnedPoints: Scalars['String']['output'];
};

export type SocialProfileMission = {
  gec: Scalars['String']['output'];
  isCompleted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  point: Scalars['String']['output'];
  unlinkable: Scalars['Boolean']['output'];
};

export type TweetMissionMeta = {
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<Scalars['String']['output']>;
  completedTwitterName?: Maybe<Scalars['String']['output']>;
  historyId?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  tweetLink?: Maybe<Scalars['String']['output']>;
};

export type Twitter = {
  avatar: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type User = {
  avatar?: Maybe<Scalars['String']['output']>;
  completedInvitations: Array<Invitation>;
  completedInviteCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  discord?: Maybe<Discord>;
  id: Scalars['ID']['output'];
  inviteCode: Scalars['String']['output'];
  inviteRewards: Scalars['Float']['output'];
  invitedBy?: Maybe<User>;
  invitedUsers: Array<User>;
  inviterBindTime?: Maybe<Scalars['DateTime']['output']>;
  inviterUpdateCount: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  pendingInvitations: Array<Invitation>;
  pendingInviteCount: Scalars['Int']['output'];
  skipInviteBind: Scalars['Boolean']['output'];
  twitter?: Maybe<Twitter>;
  updatedAt: Scalars['DateTime']['output'];
  walletAddress: Scalars['String']['output'];
};

export type UserCapsulePiece = {
  blockNumber: Scalars['String']['output'];
  dayIndex: Scalars['Int']['output'];
  tokenAddress: Scalars['String']['output'];
  tokenId: Scalars['String']['output'];
  tokenImageUrl?: Maybe<Scalars['String']['output']>;
  tokenName: Scalars['String']['output'];
};

export type UserClaimGasEligibility = {
  prerequisiteStatus: UserClaimGasEligibilityPrerequisiteStatus;
  /** NotEligible, Eligible, Completed */
  status: Scalars['String']['output'];
};

export type UserClaimGasEligibilityPrerequisiteStatus = {
  holdYesterdayNFTPiece?: Maybe<Scalars['Boolean']['output']>;
  twitterComboAction: Scalars['Boolean']['output'];
};

export type UserGecStatsV2 = {
  address: Scalars['String']['output'];
  season1Stats: Season1Stats;
  season2Stats: Season2Stats;
  season3Stats: Season3Stats;
  season4Stats: Season4Stats;
  updatedAt: Scalars['DateTime']['output'];
};

export type UserMission = {
  dayIndex?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** End date of the mission, null means the mission is always available */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  gec: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  meta: UserMissionMetaUnion;
  name: Scalars['String']['output'];
  point: Scalars['String']['output'];
  /** UnlockClaimGas */
  seriesKey?: Maybe<Scalars['String']['output']>;
  /** Start date of the mission */
  startDate: Scalars['DateTime']['output'];
  /** NotStart or InProgress or Completed or Duplicated */
  status: Scalars['String']['output'];
  /** TwitterPostRetweet or TwitterPostLike or TwitterPostComment or FreeMintNFTPiece or DiscordJoin or TwitterFollow or TwitterPostKeyword */
  type: Scalars['String']['output'];
};

export type UserMissionMetaUnion = DefaultMeta | DiscordMissionMeta | NftMissionMeta | TweetMissionMeta;

export type UserQueryVariables = Exact<{
  address: Scalars['NormalizedAddress']['input'];
}>;


export type UserQuery = { user: { avatar?: string, completedInviteCount: number, createdAt: any, id: string, inviteCode: string, inviterBindTime?: any, inviterUpdateCount: number, name?: string, pendingInviteCount: number, skipInviteBind: boolean, updatedAt: any, walletAddress: string, completedInvitations: Array<{ completedAt?: any, createdAt: any, id: string, inviteeAddress: string, inviterAddress: string, nftTokenId?: string, rewardPaid: boolean, status: string }>, invitedBy?: { avatar?: string, completedInviteCount: number, createdAt: any, id: string, inviteCode: string, inviteRewards: number, inviterBindTime?: any, inviterUpdateCount: number, name?: string, pendingInviteCount: number, skipInviteBind: boolean, updatedAt: any, walletAddress: string }, invitedUsers: Array<{ avatar?: string, completedInviteCount: number, createdAt: any, id: string, inviteCode: string, inviteRewards: number, inviterBindTime?: any, inviterUpdateCount: number, name?: string, pendingInviteCount: number, skipInviteBind: boolean, updatedAt: any, walletAddress: string }>, pendingInvitations: Array<{ completedAt?: any, createdAt: any, id: string, inviteeAddress: string, inviterAddress: string, nftTokenId?: string, rewardPaid: boolean, status: string }>, twitter?: { avatar: string, name: string }, discord?: { avatar: string, name: string } } };

export type Season1RankingsQueryVariables = Exact<{ [key: string]: never; }>;


export type Season1RankingsQuery = { season1Rankings: Array<{ address: any, rank: number, totalPoint: string, username?: string }> };

export type Season2RankingsQueryVariables = Exact<{ [key: string]: never; }>;


export type Season2RankingsQuery = { season2Rankings: Array<{ address: any, inviteeCount: number, rank: number, totalPoint: string, username?: string }> };

export type CapsulePiecesQueryVariables = Exact<{ [key: string]: never; }>;


export type CapsulePiecesQuery = { capsulePieces: Array<{ dayIndex: number, tokenAddress: string, tokenImageUrl?: string, tokenName: string }> };

export type UserRankQueryVariables = Exact<{
  address: Scalars['NormalizedAddress']['input'];
  type: Scalars['String']['input'];
}>;


export type UserRankQuery = { userRank: { address: string, inviteCount: number, rank: number, totalPoint: string } };

export type QueryUserByInviteCodeQueryVariables = Exact<{
  inviteCode: Scalars['String']['input'];
}>;


export type QueryUserByInviteCodeQuery = { queryUserByInviteCode: { avatar?: string, completedInviteCount: number, createdAt: any, id: string, inviteCode: string, inviteRewards: number, inviterBindTime?: any, inviterUpdateCount: number, name?: string, pendingInviteCount: number, skipInviteBind: boolean, updatedAt: any, walletAddress: string } };

export type UserCapsulePiecesQueryVariables = Exact<{
  address: Scalars['NormalizedAddress']['input'];
}>;


export type UserCapsulePiecesQuery = { userCapsulePieces: Array<{ blockNumber: string, tokenId: string, tokenName: string, tokenAddress: string, tokenImageUrl?: string }> };

export type UserMissionsQueryVariables = Exact<{
  address: Scalars['NormalizedAddress']['input'];
}>;


export type UserMissionsQuery = { userMissions: Array<{ dayIndex?: number, description?: string, endDate?: any, gec: string, id: number, name: string, point: string, seriesKey?: string, startDate: any, status: string, type: string, meta: { completedAt?: any, completedBy?: string, historyId?: string } | { completedAt?: any, completedBy?: string, historyId?: string, link?: string } | { completedAt?: any, completedBy?: string, historyId?: string, tokenAddress: string, tokenId?: string, tokenName: string, tokenImageUrl?: string } | { completedAt?: any, completedBy?: string, completedTwitterName?: string, historyId?: string, tweetLink?: string } }> };

export type UserSeason2MissionStatusQueryVariables = Exact<{
  address: Scalars['NormalizedAddress']['input'];
}>;


export type UserSeason2MissionStatusQuery = { userSeason2MissionStatus: Array<boolean> };

export type BindInviteCodeMutationVariables = Exact<{
  address: Scalars['NormalizedAddress']['input'];
  inviteCode: Scalars['String']['input'];
}>;


export type BindInviteCodeMutation = { bindInviteCode: { avatar?: string, completedInviteCount: number, createdAt: any, id: string, inviteCode: string, inviteRewards: number, inviterBindTime?: any, inviterUpdateCount: number, name?: string, pendingInviteCount: number, skipInviteBind: boolean, updatedAt: any, walletAddress: string } };

export type CreateUserMutationVariables = Exact<{
  address: Scalars['NormalizedAddress']['input'];
  input?: InputMaybe<CreateUserInput>;
}>;


export type CreateUserMutation = { createUser: { avatar?: string, completedInviteCount: number, createdAt: any, id: string, inviteCode: string, inviteRewards: number, inviterBindTime?: any, inviterUpdateCount: number, name?: string, pendingInviteCount: number, skipInviteBind: boolean, updatedAt: any, walletAddress: string } };

export type SkipInviteBindMutationVariables = Exact<{
  address: Scalars['NormalizedAddress']['input'];
}>;


export type SkipInviteBindMutation = { skipInviteBind: { avatar?: string, completedInviteCount: number, createdAt: any, id: string, inviteCode: string, inviteRewards: number, inviterBindTime?: any, inviterUpdateCount: number, name?: string, pendingInviteCount: number, skipInviteBind: boolean, updatedAt: any, walletAddress: string } };

export type UserGecStatsV2QueryVariables = Exact<{
  address: Scalars['NormalizedAddress']['input'];
}>;


export type UserGecStatsV2Query = { userGECStatsV2?: { address: string, updatedAt: any, season1Stats: { totalGEC: string, totalPoint: string }, season2Stats: { basicPoint: string, hbNftBoost: string, invitationBoost: string, invitationCount: number }, season3Stats: { invitationCount: number, invitationPoint: string, onChainPoint: string, socialPoint: string }, season4Stats: { totalConsumedPoints: string, totalEarnedPoints: string } } };

export type SetUserNameMutationVariables = Exact<{
  address: Scalars['NormalizedAddress']['input'];
  name: Scalars['String']['input'];
}>;


export type SetUserNameMutation = { setUserName: { avatar?: string, completedInviteCount: number, createdAt: any, id: string, inviteCode: string, inviteRewards: number, inviterBindTime?: any, inviterUpdateCount: number, name?: string, pendingInviteCount: number, skipInviteBind: boolean, updatedAt: any, walletAddress: string } };

export type StartMissionMutationVariables = Exact<{
  address: Scalars['NormalizedAddress']['input'];
  missionId: Scalars['Int']['input'];
}>;


export type StartMissionMutation = { startMission: { description?: string, endDate?: any, gec: string, id: number, name: string, point: string, startDate: any, status: string, type: string, meta: { completedAt?: any, completedBy?: string, historyId?: string } | { completedAt?: any, completedBy?: string, historyId?: string, tokenAddress: string, tokenId?: string, tokenName: string } | { completedAt?: any, completedBy?: string, completedTwitterName?: string, historyId?: string, tweetLink?: string } | {} } };

export type SyncMissionStatusMutationVariables = Exact<{
  address: Scalars['NormalizedAddress']['input'];
  historyId: Scalars['String']['input'];
}>;


export type SyncMissionStatusMutation = { syncMissionStatus: { description?: string, endDate?: any, gec: string, id: number, name: string, point: string, startDate: any, status: string, type: string, meta: { completedAt?: any, completedBy?: string, historyId?: string } | { completedAt?: any, completedBy?: string, historyId?: string, tokenAddress: string, tokenId?: string, tokenName: string } | { completedAt?: any, completedBy?: string, completedTwitterName?: string, historyId?: string, tweetLink?: string } | {} } };

export type CapsuleMintPermitQueryVariables = Exact<{
  address: Scalars['String']['input'];
}>;


export type CapsuleMintPermitQuery = { capsuleMintPermit: { permit: string } };

export type GlobalQueryVariables = Exact<{ [key: string]: never; }>;


export type GlobalQuery = { global: { totalParticipants: number, totalTransactions: number, totalTvl: number, capsuleNFT: { abi: string, contractAddress: string, mintedCount: number } } };

export type LuckyDrawUserStatsQueryVariables = Exact<{
  address: Scalars['NormalizedAddress']['input'];
}>;


export type LuckyDrawUserStatsQuery = { luckyDrawUserStats: { todayConsumedDraws: number, todayEligibility: boolean, todayMaxDraws: number, todayOnChainTaskEligibility: boolean, todayRemainingDraws: number, totalAvailableDraws: number, totalConsumedDraws: number, totalConsumedPoints: string, totalEarnedPoints: string, totalRemainingPoints: string, totalRewards: Array<{ drawnCount: number, index: number }> } };

export type LuckyDrawUserHistoriesQueryVariables = Exact<{
  address: Scalars['NormalizedAddress']['input'];
  pagination: GetRecordsPaginationInput;
}>;


export type LuckyDrawUserHistoriesQuery = { luckyDrawUserHistories: { items: Array<{ createdAt: string, drawCount: number, drawDate: string, id: string, txHash: string, rewards: Array<{ drawnCount: number, index: number }> }>, pagination: { page: number, pageSize: number, total: number } } };

export type LuckyDrawPreparationMutationVariables = Exact<{
  address: Scalars['NormalizedAddress']['input'];
  signature: Scalars['String']['input'];
  value: PrepareDrawValue;
}>;


export type LuckyDrawPreparationMutation = { luckyDrawPreparation: { drawCount: number, expiresAt: number, historyId: string, signature: string } };

export type LuckyDrawRewardsQueryVariables = Exact<{ [key: string]: never; }>;


export type LuckyDrawRewardsQuery = { luckyDrawRewards: Array<{ amount: string, decimal: number, index: number, isActive: boolean, key: string, maxDrawPerRound: number, name: string, weight: string }> };

export type LuckyDrawCurrentRoundStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type LuckyDrawCurrentRoundStatsQuery = { luckyDrawCurrentRoundStats: { round: number, totalDrawCount: number, uniqueUsersCount: number, pointsPerDraw: string, rewardDrawn: Array<{ drawnCount: number, index: number }> } };

export type LuckyDrawSaveTxHashMutationVariables = Exact<{
  address: Scalars['NormalizedAddress']['input'];
  historyId: Scalars['String']['input'];
  txHash: Scalars['String']['input'];
}>;


export type LuckyDrawSaveTxHashMutation = { luckyDrawSaveTxHash: boolean };


export const UserDocument = gql`
    query user($address: NormalizedAddress!) {
  user(address: $address) {
    avatar
    completedInviteCount
    createdAt
    id
    inviteCode
    inviterBindTime
    inviterUpdateCount
    name
    pendingInviteCount
    skipInviteBind
    updatedAt
    walletAddress
    completedInvitations {
      completedAt
      createdAt
      id
      inviteeAddress
      inviterAddress
      nftTokenId
      rewardPaid
      status
    }
    invitedBy {
      avatar
      completedInviteCount
      createdAt
      id
      inviteCode
      inviteRewards
      inviterBindTime
      inviterUpdateCount
      name
      pendingInviteCount
      skipInviteBind
      updatedAt
      walletAddress
    }
    invitedUsers {
      avatar
      completedInviteCount
      createdAt
      id
      inviteCode
      inviteRewards
      inviterBindTime
      inviterUpdateCount
      name
      pendingInviteCount
      skipInviteBind
      updatedAt
      walletAddress
    }
    pendingInvitations {
      completedAt
      createdAt
      id
      inviteeAddress
      inviterAddress
      nftTokenId
      rewardPaid
      status
    }
    twitter {
      avatar
      name
    }
    discord {
      avatar
      name
    }
  }
}
    `;
export const Season1RankingsDocument = gql`
    query season1Rankings {
  season1Rankings {
    address
    rank
    totalPoint
    username
  }
}
    `;
export const Season2RankingsDocument = gql`
    query season2Rankings {
  season2Rankings {
    address
    inviteeCount
    rank
    totalPoint
    username
  }
}
    `;
export const CapsulePiecesDocument = gql`
    query capsulePieces {
  capsulePieces {
    dayIndex
    tokenAddress
    tokenImageUrl
    tokenName
  }
}
    `;
export const UserRankDocument = gql`
    query userRank($address: NormalizedAddress!, $type: String!) {
  userRank(address: $address, type: $type) {
    address
    inviteCount
    rank
    totalPoint
  }
}
    `;
export const QueryUserByInviteCodeDocument = gql`
    query queryUserByInviteCode($inviteCode: String!) {
  queryUserByInviteCode(inviteCode: $inviteCode) {
    avatar
    completedInviteCount
    createdAt
    id
    inviteCode
    inviteRewards
    inviterBindTime
    inviterUpdateCount
    name
    pendingInviteCount
    skipInviteBind
    updatedAt
    walletAddress
  }
}
    `;
export const UserCapsulePiecesDocument = gql`
    query userCapsulePieces($address: NormalizedAddress!) {
  userCapsulePieces(address: $address) {
    blockNumber
    tokenId
    tokenName
    tokenAddress
    tokenImageUrl
  }
}
    `;
export const UserMissionsDocument = gql`
    query userMissions($address: NormalizedAddress!) {
  userMissions(address: $address) {
    dayIndex
    description
    endDate
    gec
    id
    name
    point
    seriesKey
    startDate
    status
    type
    meta {
      ... on DiscordMissionMeta {
        completedAt
        completedBy
        historyId
        link
      }
      ... on DefaultMeta {
        completedAt
        completedBy
        historyId
      }
      ... on NFTMissionMeta {
        completedAt
        completedBy
        historyId
        tokenAddress
        tokenId
        tokenName
        tokenImageUrl
      }
      ... on TweetMissionMeta {
        completedAt
        completedBy
        completedTwitterName
        historyId
        tweetLink
      }
    }
  }
}
    `;
export const UserSeason2MissionStatusDocument = gql`
    query userSeason2MissionStatus($address: NormalizedAddress!) {
  userSeason2MissionStatus(address: $address)
}
    `;
export const BindInviteCodeDocument = gql`
    mutation bindInviteCode($address: NormalizedAddress!, $inviteCode: String!) {
  bindInviteCode(address: $address, inviteCode: $inviteCode) {
    avatar
    completedInviteCount
    createdAt
    id
    inviteCode
    inviteRewards
    inviterBindTime
    inviterUpdateCount
    name
    pendingInviteCount
    skipInviteBind
    updatedAt
    walletAddress
  }
}
    `;
export const CreateUserDocument = gql`
    mutation createUser($address: NormalizedAddress!, $input: CreateUserInput) {
  createUser(address: $address, input: $input) {
    avatar
    completedInviteCount
    createdAt
    id
    inviteCode
    inviteRewards
    inviterBindTime
    inviterUpdateCount
    name
    pendingInviteCount
    skipInviteBind
    updatedAt
    walletAddress
  }
}
    `;
export const SkipInviteBindDocument = gql`
    mutation skipInviteBind($address: NormalizedAddress!) {
  skipInviteBind(address: $address) {
    avatar
    completedInviteCount
    createdAt
    id
    inviteCode
    inviteRewards
    inviterBindTime
    inviterUpdateCount
    name
    pendingInviteCount
    skipInviteBind
    updatedAt
    walletAddress
  }
}
    `;
export const UserGecStatsV2Document = gql`
    query UserGECStatsV2($address: NormalizedAddress!) {
  userGECStatsV2(address: $address) {
    address
    season1Stats {
      totalGEC
      totalPoint
    }
    season2Stats {
      basicPoint
      hbNftBoost
      invitationBoost
      invitationCount
    }
    season3Stats {
      invitationCount
      invitationPoint
      onChainPoint
      socialPoint
    }
    season4Stats {
      totalConsumedPoints
      totalEarnedPoints
    }
    updatedAt
  }
}
    `;
export const SetUserNameDocument = gql`
    mutation setUserName($address: NormalizedAddress!, $name: String!) {
  setUserName(address: $address, name: $name) {
    avatar
    completedInviteCount
    createdAt
    id
    inviteCode
    inviteRewards
    inviterBindTime
    inviterUpdateCount
    name
    pendingInviteCount
    skipInviteBind
    updatedAt
    walletAddress
  }
}
    `;
export const StartMissionDocument = gql`
    mutation startMission($address: NormalizedAddress!, $missionId: Int!) {
  startMission(address: $address, missionId: $missionId) {
    description
    endDate
    gec
    id
    meta {
      ... on DefaultMeta {
        completedAt
        completedBy
        historyId
      }
      ... on NFTMissionMeta {
        completedAt
        completedBy
        historyId
        tokenAddress
        tokenId
        tokenName
      }
      ... on TweetMissionMeta {
        completedAt
        completedBy
        completedTwitterName
        historyId
        tweetLink
      }
    }
    name
    point
    startDate
    status
    type
  }
}
    `;
export const SyncMissionStatusDocument = gql`
    mutation syncMissionStatus($address: NormalizedAddress!, $historyId: String!) {
  syncMissionStatus(address: $address, historyId: $historyId) {
    description
    endDate
    gec
    id
    meta {
      ... on DefaultMeta {
        completedAt
        completedBy
        historyId
      }
      ... on NFTMissionMeta {
        completedAt
        completedBy
        historyId
        tokenAddress
        tokenId
        tokenName
      }
      ... on TweetMissionMeta {
        completedAt
        completedBy
        completedTwitterName
        historyId
        tweetLink
      }
    }
    name
    point
    startDate
    status
    type
  }
}
    `;
export const CapsuleMintPermitDocument = gql`
    query capsuleMintPermit($address: String!) {
  capsuleMintPermit(address: $address) {
    permit
  }
}
    `;
export const GlobalDocument = gql`
    query global {
  global {
    capsuleNFT {
      abi
      contractAddress
      mintedCount
    }
    totalParticipants
    totalTransactions
    totalTvl
  }
}
    `;
export const LuckyDrawUserStatsDocument = gql`
    query LuckyDrawUserStats($address: NormalizedAddress!) {
  luckyDrawUserStats(address: $address) {
    todayConsumedDraws
    todayEligibility
    todayMaxDraws
    todayOnChainTaskEligibility
    todayRemainingDraws
    totalAvailableDraws
    totalConsumedDraws
    totalConsumedPoints
    totalEarnedPoints
    totalRemainingPoints
    totalRewards {
      drawnCount
      index
    }
  }
}
    `;
export const LuckyDrawUserHistoriesDocument = gql`
    query luckyDrawUserHistories($address: NormalizedAddress!, $pagination: GetRecordsPaginationInput!) {
  luckyDrawUserHistories(address: $address, pagination: $pagination) {
    items {
      createdAt
      drawCount
      drawDate
      id
      rewards {
        drawnCount
        index
      }
      txHash
    }
    pagination {
      page
      pageSize
      total
    }
  }
}
    `;
export const LuckyDrawPreparationDocument = gql`
    mutation luckyDrawPreparation($address: NormalizedAddress!, $signature: String!, $value: PrepareDrawValue!) {
  luckyDrawPreparation(address: $address, signature: $signature, value: $value) {
    drawCount
    expiresAt
    historyId
    signature
  }
}
    `;
export const LuckyDrawRewardsDocument = gql`
    query luckyDrawRewards {
  luckyDrawRewards {
    amount
    decimal
    index
    isActive
    key
    maxDrawPerRound
    name
    weight
  }
}
    `;
export const LuckyDrawCurrentRoundStatsDocument = gql`
    query luckyDrawCurrentRoundStats {
  luckyDrawCurrentRoundStats {
    rewardDrawn {
      drawnCount
      index
    }
    round
    totalDrawCount
    uniqueUsersCount
    pointsPerDraw
  }
}
    `;
export const LuckyDrawSaveTxHashDocument = gql`
    mutation luckyDrawSaveTxHash($address: NormalizedAddress!, $historyId: String!, $txHash: String!) {
  luckyDrawSaveTxHash(address: $address, historyId: $historyId, txHash: $txHash)
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    user(variables: UserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserQuery>(UserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'user', 'query', variables);
    },
    season1Rankings(variables?: Season1RankingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Season1RankingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Season1RankingsQuery>(Season1RankingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'season1Rankings', 'query', variables);
    },
    season2Rankings(variables?: Season2RankingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Season2RankingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Season2RankingsQuery>(Season2RankingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'season2Rankings', 'query', variables);
    },
    capsulePieces(variables?: CapsulePiecesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CapsulePiecesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CapsulePiecesQuery>(CapsulePiecesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'capsulePieces', 'query', variables);
    },
    userRank(variables: UserRankQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserRankQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserRankQuery>(UserRankDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userRank', 'query', variables);
    },
    queryUserByInviteCode(variables: QueryUserByInviteCodeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QueryUserByInviteCodeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QueryUserByInviteCodeQuery>(QueryUserByInviteCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'queryUserByInviteCode', 'query', variables);
    },
    userCapsulePieces(variables: UserCapsulePiecesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserCapsulePiecesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserCapsulePiecesQuery>(UserCapsulePiecesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userCapsulePieces', 'query', variables);
    },
    userMissions(variables: UserMissionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserMissionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserMissionsQuery>(UserMissionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userMissions', 'query', variables);
    },
    userSeason2MissionStatus(variables: UserSeason2MissionStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserSeason2MissionStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserSeason2MissionStatusQuery>(UserSeason2MissionStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userSeason2MissionStatus', 'query', variables);
    },
    bindInviteCode(variables: BindInviteCodeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BindInviteCodeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BindInviteCodeMutation>(BindInviteCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bindInviteCode', 'mutation', variables);
    },
    createUser(variables: CreateUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateUserMutation>(CreateUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createUser', 'mutation', variables);
    },
    skipInviteBind(variables: SkipInviteBindMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SkipInviteBindMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SkipInviteBindMutation>(SkipInviteBindDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'skipInviteBind', 'mutation', variables);
    },
    UserGECStatsV2(variables: UserGecStatsV2QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserGecStatsV2Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserGecStatsV2Query>(UserGecStatsV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UserGECStatsV2', 'query', variables);
    },
    setUserName(variables: SetUserNameMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetUserNameMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetUserNameMutation>(SetUserNameDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setUserName', 'mutation', variables);
    },
    startMission(variables: StartMissionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StartMissionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<StartMissionMutation>(StartMissionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'startMission', 'mutation', variables);
    },
    syncMissionStatus(variables: SyncMissionStatusMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SyncMissionStatusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SyncMissionStatusMutation>(SyncMissionStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'syncMissionStatus', 'mutation', variables);
    },
    capsuleMintPermit(variables: CapsuleMintPermitQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CapsuleMintPermitQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CapsuleMintPermitQuery>(CapsuleMintPermitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'capsuleMintPermit', 'query', variables);
    },
    global(variables?: GlobalQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GlobalQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GlobalQuery>(GlobalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'global', 'query', variables);
    },
    LuckyDrawUserStats(variables: LuckyDrawUserStatsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LuckyDrawUserStatsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LuckyDrawUserStatsQuery>(LuckyDrawUserStatsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LuckyDrawUserStats', 'query', variables);
    },
    luckyDrawUserHistories(variables: LuckyDrawUserHistoriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LuckyDrawUserHistoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LuckyDrawUserHistoriesQuery>(LuckyDrawUserHistoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'luckyDrawUserHistories', 'query', variables);
    },
    luckyDrawPreparation(variables: LuckyDrawPreparationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LuckyDrawPreparationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LuckyDrawPreparationMutation>(LuckyDrawPreparationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'luckyDrawPreparation', 'mutation', variables);
    },
    luckyDrawRewards(variables?: LuckyDrawRewardsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LuckyDrawRewardsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LuckyDrawRewardsQuery>(LuckyDrawRewardsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'luckyDrawRewards', 'query', variables);
    },
    luckyDrawCurrentRoundStats(variables?: LuckyDrawCurrentRoundStatsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LuckyDrawCurrentRoundStatsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LuckyDrawCurrentRoundStatsQuery>(LuckyDrawCurrentRoundStatsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'luckyDrawCurrentRoundStats', 'query', variables);
    },
    luckyDrawSaveTxHash(variables: LuckyDrawSaveTxHashMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LuckyDrawSaveTxHashMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LuckyDrawSaveTxHashMutation>(LuckyDrawSaveTxHashDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'luckyDrawSaveTxHash', 'mutation', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;